import { evaluateConfig } from "@crystal/core";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import { getRuntimeInfo } from "../integration/state-getters.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import "@crystal/analytics";
import { getExternalTouchpointParameters } from "./external-parameters.js";
import "./presets.js";
import { sourceIds } from "./source-ids.js";
import "../ap2/config.js";
import "../ap2/state.js";
import "../external-auth/config.js";
import "@crystal/config";
var Scenario = /* @__PURE__ */ ((Scenario2) => {
  Scenario2["Registration"] = "REGISTRATION";
  Scenario2["Activation"] = "ACTIVATION";
  return Scenario2;
})(Scenario || {});
function getSourceId(touchpoint, scenario) {
  const { propSourceId } = getRuntimeInfo();
  const externalTouchpointParameters = getExternalTouchpointParameters();
  const { registrationSourceIds, activationSourceIds } = evaluateConfig(sourceIds);
  switch (scenario) {
    case "REGISTRATION":
      return propSourceId || (externalTouchpointParameters == null ? void 0 : externalTouchpointParameters.sourceId) || registrationSourceIds[touchpoint];
    case "ACTIVATION":
      return activationSourceIds[touchpoint];
    default:
      throw new Error(`All cases must be defined: ${scenario}`);
  }
}
export {
  Scenario,
  getSourceId
};
//# sourceMappingURL=source-id-utils.js.map
